module.exports = __webpack_public_path__ + "static/media/vinImportTemp.e48a48e0.xlsx";